/* Built In Imports */
import NextLink from 'next/link';
import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

/* External Imports */
import { Box, Button, Flex, Link, Spacer, Text, Image } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';

/* Services */
/* Config */
import config from '@config';
import { TopBannerSt } from '@ieo/Common/CompLangConfig';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import InlineEnquireForm from './InlineEnquireForm';
import { IoLogoWhatsapp } from 'react-icons/io5';
import WPChatButton from './WPChatButton';
import { nanoid } from 'nanoid';
import { usePathname } from 'next/navigation';
import { mixPanel } from '@utils/Mixpanel';
import SingleImage from './SingleImage';
import ProgressiveBg from '@components/UI/ProgressiveBg';
const BannerImage = dynamic(() => import('./BannerImage'), {
  ssr: false,
});

/* Styles */

/**
 * @param {Object} sectionContent
 * @param {Object} pageData
 * @param {String} lang
 * @param {String} region
 * @returns
 */
const TopBannerEvent = ({
  sectionContent,
  region,
  lang,
  pageData,
  pageName,
  pageConfig,
}) => {
  const isLessThen = useMediaQuery({ maxWidth: 767 });
  const [isPopup, setIsPopup] = useState(false);
  const [resultArr, setResultArr] = useState([]);
  const [isCatOpen, setCatIsOpen] = useState(false);
  const pathname = usePathname();

  const pageConfigVal = pageConfig?.[0]?.value;

  const isWavesOfBlissWAPage =
    pathname.endsWith('wave-of-bliss-bengaluru-wa') ||
    pathname.endsWith('wave-of-bliss-uttar-pradesh-wa');
  const isWavesOfBlissILPage =
    pathname.endsWith('wave-of-bliss-bengaluru-il') ||
    pathname.endsWith('wave-of-bliss-uttar-pradesh-il');
  const isWavesOfBlissLandingPage =
    pathname.endsWith('wave-of-bliss-bengaluru') ||
    pathname.endsWith('wave-of-bliss-uttar-pradesh');
  const isWavesOfBlissUPPage = pathname.includes('wave-of-bliss-uttar-pradesh');

  useEffect(() => {
    const langArr = [];
    config.orderedLang.forEach(language => {
      const newProgs = pageData?.alsoin?.filter(itm => {
        return (
          itm.url ===
          window?.location?.pathname.replace(`/${lang}/`, `/${language}/`)
        );
      });
      if (newProgs?.length > 0) {
        langArr.push(newProgs[0]);
      }
    });
    setResultArr(langArr);
  }, [pathname]);

  const mixPanelEventTrigger = () => {
    const Mixpanel = mixPanel(window?.location.pathname);
    if (isWavesOfBlissLandingPage) {
      Mixpanel.track('ie_wave_registration_cta_click', {
        element: 'REGISTER NOW',
        language: config?.lngList?.[lang],
        cta: 'top cta',
      });
    }
    if (isWavesOfBlissWAPage) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ie_wave_lead_wa_button_clicked',
        program_name: isWavesOfBlissUPPage ? 'IE Wave - UP' : 'IE Wave - BLR',
        Button_Location: 'Top_CTA',
      });
      Mixpanel.track('ie_wave_chat_with_us_click', {
        page_name: 'Whatsapp Bot page',
        element: 'Chat with us',
        language: config?.lngList?.[lang],
        cta: 'top cta',
      });
    }
    if (isWavesOfBlissILPage) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ie_wave_lead_web_button_clicked',
        program_name: isWavesOfBlissUPPage ? 'IE Wave - UP' : 'IE Wave - BLR',
        Button_Location: 'Top_CTA',
      });
      Mixpanel.track('ie_wave_enquire_now_click', {
        page_name: 'Inline form page',
        element: 'Enquire Now',
        language: config?.lngList?.[lang],
        cta: 'top cta',
      });
    }
  };

  const RightIcon = ({ hover }) => {
    return (
      <svg
        width="16"
        height="10"
        viewBox="0 0 18 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L8.99998 9L17 1"
          stroke={hover ? '#BC570F' : '#F37021'}
          stroke-width="2.66667"
        />
      </svg>
    );
  };
  const getSimpleButton = () => {
    if (isWavesOfBlissWAPage) {
      return (
        <SimpleButton
          w={'max-content'}
          minW="210px"
          pr="20px"
          background={'#fff !important'}
          h={{ base: '69px' }}
          textAlign="center"
          mb={'0'}
          mt={'0'}
          mx={{ base: 'auto', md: '0', lg: 'auto' }}
          _hover={{
            background: '#fff !important',
          }}
          borderRadius={'50px !important'}
          style={{
            buttonStyle: 'Orange',
            buttonText: (
              <Flex
                color={'#000000'}
                fontSize={'18px'}
                fontWeight={'500'}
                fontFamily={'FedraSansStd-medium'}
                gap={'9px'}
              >
                <Box
                  w="59px"
                  h="59px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="50px"
                  bg="#00E676"
                >
                  <IoLogoWhatsapp size={38} color="white" />
                </Box>
                {sectionContent[3]?.buttonText}
              </Flex>
            ),
          }}
          srcImg={pageData}
          onClick={() => {
            mixPanelEventTrigger();
            if (!isWavesOfBlissLandingPage) {
              setIsPopup(true);
            }
          }}
          padding={{
            base: '5.5px 5.5px',
          }}
          lineHeight={{
            base: '58px',
          }}
          zIndex={100}
          useBlankStringURLOnLink={isWavesOfBlissWAPage || isWavesOfBlissILPage}
        ></SimpleButton>
      );
    }
    return (
      <SimpleButton
        minW="226px"
        background={'#ffffff !important'}
        h={{ base: '60px' }}
        textAlign="center"
        mb={'0'}
        mt={'0'}
        mx={{ base: 'auto', md: '0', lg: 'auto' }}
        _hover={{
          background: '#F2F2F2 !important',
        }}
        color="#000000"
        fontWeight={'500'}
        borderRadius={'10px !important'}
        style={sectionContent[3]}
        srcImg={pageData}
        onClick={() => {
          mixPanelEventTrigger();
          if (!isWavesOfBlissLandingPage) {
            setIsPopup(true);
          }
        }}
        padding={{
          base: '10px 29px',
        }}
        lineHeight={{
          base: '40px',
        }}
        fontSize={{
          base: '22px',
        }}
        zIndex={100}
        useBlankStringURLOnLink={isWavesOfBlissWAPage || isWavesOfBlissILPage}
      ></SimpleButton>
    );
  };

  const getSadGuruImage = () => {
    return (
      <BannerImage
        px="0"
        w={{ base: '100%', sm: 'auto', md: 'auto' }}
        className="sadhguruImage"
        height="full"
        mb="0"
        sectionContent={sectionContent[1]}
        sync="true"
        objectFit="contain"
        bottom="0"
        maxWidthPx={481}
      />
    );
  };

  return (
    <>
      <Box id="banner" maxH={{ base: '90vh', sm: '100%' }} overflow="hidden">
        <ProgressiveBg
          backgroundImage={{
            base: pageConfigVal?.topbanner?.topAd?.mob,
            sm: pageConfigVal?.topbanner?.topAd?.mob,
            md:
              pageConfigVal?.topbanner?.topAd?.tab ||
              pageConfigVal?.topbanner?.topAd?.desktop,
            lg: pageConfigVal?.topbanner?.topAd?.desktop,
            xl: pageConfigVal?.topbanner?.topAd?.bigScreen,
            '2xl': pageConfigVal?.topbanner?.topAd?.bigScreen,
          }}
          bgColor={'#f4f4f4'}
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          position="relative"
          h={{
            base: 'auto',
          }}
          pt={{ base: '15px', md: '15px' }}
          pb={{ base: '15px', md: '15px' }}
          px={{ base: '16px' }}
          lazyLoad
        >
          <StructuredTextParser
            str={render(sectionContent?.[6]?.body)}
            mt="0px"
            fontSize={{ base: '14px', md: '24px' }}
            color={{ base: '#3B444B', md: '#121212' }}
            fontWeight="500"
            textAlign="center"
            lineHeight={{ base: '18px', md: '30px' }}
            pb="6px"
            fontFamily={'FedraSansStd-book'}
          />
          <StructuredTextParser
            str={render(sectionContent?.[8]?.body)}
            mt="0px"
            fontSize={{ base: '12px', md: '16px' }}
            color={{ base: '#000000', md: '#000000' }}
            textAlign="center"
            lineHeight={{ base: '16px', md: '16px' }}
            maxW="100%"
            fontFamily={'FedraSansStd-book'}
          />
        </ProgressiveBg>
        <ProgressiveBg
          backgroundImage={{
            base: pageConfigVal?.topbanner?.bgImage?.mob,
            sm: pageConfigVal?.topbanner?.bgImage?.tab,
            md:
              pageConfigVal?.topbanner?.bgImage?.tab ||
              pageConfigVal?.topbanner?.bgImage?.desktop,
            lg: pageConfigVal?.topbanner?.bgImage?.desktop,
            xl: pageConfigVal?.topbanner?.bgImage?.desktop,
            '2xl': pageConfigVal?.topbanner?.bgImage?.bigScreen,
          }}
          bgColor={'#f4f4f4'}
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          position="relative"
          className="wavesOfBlissBanner"
          overflow="hidden"
          lazyLoad
        >
          <SingleImage
            display={{ md: 'block' }}
            sectionContent={sectionContent[9]}
            position="absolute"
            objectPosition="bottom"
            top={{ base: '0', md: 'auto' }}
            bottom={{ base: 'auto', md: '0' }}
            left="0"
            my="0px"
            px="0px"
            lang={lang}
            w={{ base: '100%', md: '100%', lg: '100%' }}
            h={{ base: '100%', md: '100%', lg: '100%' }}
            maxW={{ base: '100%', md: '10%', xl: '13%', '2xl': '15%' }}
            maxWidthPx={767}
            zIndex={{ base: 3, md: 3 }}
            lineHeight="0px"
          />
          <SingleImage
            display={{ md: 'block' }}
            sectionContent={sectionContent[10]}
            position="absolute"
            objectPosition="bottom"
            top={{ base: 'auto', md: '0' }}
            bottom={{ base: '0', md: 'auto' }}
            right="0"
            my="0px"
            px="0px"
            lang={lang}
            w={{ base: '100%', md: '100%', lg: '100%' }}
            h={{ base: '100%', md: '100%', lg: '100%' }}
            maxW={{ base: '100%', md: '15%', lg: '15%' }}
            maxWidthPx={767}
            zIndex={{ base: 4, md: 1 }}
            lineHeight="0px"
          />
          <Box
            position="absolute"
            bottom="0"
            left="0"
            right="0"
            height={{ base: '179px', md: '281px' }}
            bg="linear-gradient(180deg, rgba(16, 31, 72, 0) 42.31%, #102049 100%)"
            zIndex={3}
          />
          <Flex mx={'auto'} justifyContent={'center'}>
            <Flex
              flexDir="row"
              justify={{ base: 'space-between', sm: 'flex-end' }}
              position={'absolute'}
              w={'100%'}
              pt={{ base: '22px', sm: '24px' }}
              alignItems="center"
              gap={{ base: '20px', sm: '34px' }}
              maxW={'1180px'}
              px={{ base: '16px', sm: '30px', xl: '0px' }}
              zIndex={20}
            >
              {pageData?.alsoin?.length > 0 ? (
                <Button
                  id="banner-language-switcher"
                  bg="transparent"
                  value={config.lngListTrans[lang]}
                  color="#B7987E"
                  fontSize={{ base: '16px', md: '18px' }}
                  variant="link"
                  w="auto"
                  rounded="full"
                  fontWeight={350}
                  display="inline-flex"
                  _hover={{ border: '0px solid #B7987E' }}
                  _focus={{ border: '0px solid #B7987E' }}
                  _active={{ border: '0px solid #B7987E' }}
                  rightIcon={<RightIcon hover={false} />}
                  // onMouseOver={(e)=>{e.preventDefault(); setHover(true)}}
                  // onMouseOut={(e)=>{e.preventDefault(); setHover(false)}}
                  onClick={() => setCatIsOpen(!isCatOpen)}
                  //  onBlur={() => setCatIsOpen(false)}
                  className="selectButton"
                  textTransform="capitalize"
                  {...TopBannerSt[lang]?.loginButton}
                  mr={{ base: '0px' }}
                  mt={{
                    base: lang === 'es' && '20px',
                    md: lang === 'es' && '22px',
                  }}
                  justifyContent="center"
                  zIndex={16}
                >
                  <Text
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    w="auto"
                    minW="60px"
                    {...TopBannerSt[lang]?.loginButton}
                    fontSize={{ base: '16px', md: '18px' }}
                    color={{ base: '#fff', md: '#F37021' }}
                    _hover={{ color: { base: '#F37021', md: '#fff' } }}
                    letterSpacing={{ base: 'normal', md: '0' }}
                    fontWeight={{ base: '500', md: '500' }}
                    textAlign="center"
                    pl={'22px'}
                    h={'24px'}
                  >
                    {config.lngListTrans[lang]}
                  </Text>
                  {isCatOpen && (
                    <Flex
                      whiteSpace="break-spaces"
                      className="options"
                      alignItems="flex-start"
                      alignContent="flex-start"
                      {...TopBannerSt?.[lang]?.loginButton}
                      position="absolute"
                      top={{ base: '45px', md: '47px' }}
                      zIndex="100"
                      left="0"
                      boxShadow="0px 0.75926px 2.36111px 0px rgba(0, 0, 0, 0.03), 0px 3.34074px 4.88889px 0px rgba(0, 0, 0, 0.05), 0px 8.2px 9.75px 0px rgba(0, 0, 0, 0.06), 0px 15.79259px 19.11111px 0px rgba(0, 0, 0, 0.07), 0px 26.57407px 35.13889px 0px rgba(0, 0, 0, 0.09), 0px 41px 60px 0px rgba(0, 0, 0, 0.12)"
                      w={{ base: '103px', md: '116px' }}
                      flexDir="column"
                      bg="#ffffff"
                      mt={{ base: '0', md: '0' }}
                      p={{ base: '10px 0', md: '10px 0' }}
                      cursor="default"
                      ml={'22px'}
                    >
                      {region === 'in'
                        ? resultArr?.map((lg, i) => {
                            return (
                              <Link
                                href={lg?.url}
                                w={'100%'}
                                passHref
                                legacyBehavior
                              >
                                <Box
                                  padding="8px 0"
                                  cursor="pointer"
                                  key={nanoid()}
                                  value={lg}
                                  w={'100%'}
                                >
                                  <Text
                                    textAlign="left"
                                    padding="0 15px"
                                    fontFamily={TopBannerSt[lang].loginButton}
                                    color="#6D6358"
                                    _hover={{
                                      color: '#BC570F',
                                      fontWeight: '400',
                                      textAlign: 'left',
                                    }}
                                    _active={{
                                      color: '#BC570F',
                                      fontWeight: '400',
                                      textAlign: 'left',
                                    }}
                                    _focus={{
                                      color: '#BC570F',
                                      fontWeight: '400',
                                      textAlign: 'left',
                                    }}
                                  >
                                    {lg.title}
                                  </Text>
                                </Box>
                              </Link>
                            );
                          })
                        : pageData.alsoin?.map((lg, i) => {
                            return (
                              <Link
                                href={lg?.url}
                                w={'100%'}
                                passHref
                                legacyBehavior
                              >
                                <Box
                                  padding="8px 0"
                                  cursor="pointer"
                                  key={nanoid()}
                                  value={lg}
                                  w={'100%'}
                                >
                                  <Text
                                    textAlign="left"
                                    padding="0 15px"
                                    fontFamily={TopBannerSt[lang].loginButton}
                                    color="#6D6358"
                                    _hover={{
                                      color: '#BC570F',
                                      fontWeight: '400',
                                      textAlign: 'left',
                                    }}
                                    _active={{
                                      color: '#BC570F',
                                      fontWeight: '400',
                                      textAlign: 'left',
                                    }}
                                    _focus={{
                                      color: '#BC570F',
                                      fontWeight: '400',
                                      textAlign: 'left',
                                    }}
                                  >
                                    {lg.title === 'Indonesian'
                                      ? 'Bahasa Indonesia'
                                      : lg.title}{' '}
                                  </Text>
                                </Box>
                              </Link>
                            );
                          })}
                    </Flex>
                  )}
                </Button>
              ) : (
                <Spacer />
              )}

              <Flex
                flexDir="column"
                alignItems="flex-end"
                justify="space-between"
                pr={{ base: '22px', sm: '0' }}
              >
                <Box
                  as="span"
                  fontSize={{ base: '12px', md: '14px' }}
                  color={{ base: '#fff', md: '#fff' }}
                  {...TopBannerSt[lang]?.loginButton}
                  letterSpacing={{ base: 'normal', md: '0' }}
                  fontWeight={{ base: '400', md: '500' }}
                  textAlign="end"
                  w="auto"
                  lineHeight={'15px'}
                >
                  {/* Already registered text */}
                  {sectionContent[4]?.text}
                </Box>
                <NextLink
                  href={config.EMAIL_LOGIN_URL.replace('[EMAIL]', '')}
                  passHref
                  legacyBehavior
                >
                  <Link
                    zIndex={16}
                    id="banner-login-button"
                    {...TopBannerSt[lang]?.loginButton}
                    color={{ base: '#fff' }}
                    fontWeight={500}
                    height={{ base: '30px', md: '43px' }}
                    padding={{
                      base: '0 22px',
                      md: '0 33px',
                    }}
                    fontSize={{ base: '14px', md: '18px' }}
                    borderRadius={0}
                    textAlign="center"
                    w={{ base: 'max-content' }}
                    _hover={{
                      bg: '#BC570F',
                      color: '#fff',
                      border: '1px solid #BC570F !important',
                    }}
                    _active={{
                      bg: '#BC570F',
                      color: '#fff',
                      border: '1px solid #BC570F !important',
                    }}
                    _focus={{
                      bg: region !== 'us' && region !== 'ca' && '#BC570F',
                      color: '#fff',
                      border: '1px solid #BC570F !important',
                    }}
                    value="login"
                    h={{ base: 'auto', md: 'auto' }}
                    borderWidth="0"
                    border="1px solid #CE6113 !important"
                    lineHeight={{ base: '30px', md: '43px' }}
                    mt={{
                      base: '6px',
                      lg: region === 'us' || region === 'ca' ? '6px' : '6px',
                    }}
                    target="_blank"
                  >
                    {sectionContent[5]?.buttonText}
                  </Link>
                </NextLink>
              </Flex>
            </Flex>
          </Flex>

          <Box
            h={'full'}
            maxW={'1920px'}
            mx={{ base: 'auto' }}
            position={'relative'}
          >
            <Box
              maxW={'1180px'}
              mx={{ base: 'auto' }}
              display="grid"
              gridTemplateColumns={{
                base: '1fr',
                sm: '60% 40%',
                lg: '60% 40%',
                xl: '56% 44%',
                '2xl': '55% 45%',
              }}
              justifyContent="center"
              h={'full'}
              pt={{ base: '75px', sm: '40px', md: '0px' }}
              pb={{ base: '0px', sm: '40px', md: '0px' }}
            >
              <Box
                mx="auto"
                w="full"
                h="100%"
                display="flex"
                alignItems="center"
                justify="center"
              >
                <Flex
                  flexDirection="column"
                  textAlign="center"
                  alignItems="center"
                  justifyContent={{
                    base: 'center',
                  }}
                  mx={{ base: 'auto', md: '0' }}
                  gap={{ base: '15px', md: '34px' }}
                  style={sectionContent[4]}
                  zIndex={10}
                  px={{ base: '16px', md: '30px', xl: '0px' }}
                >
                  <SingleImage
                    mt={{ base: '34px', sm: '0' }}
                    mx="auto"
                    objectFit="contain"
                    alignSelf={{
                      base: 'center',
                      sm: 'flex-start',
                      lg: 'center',
                    }}
                    sectionContent={sectionContent[0]}
                    alt="waves of bliss text"
                    sync="true"
                    ml={{ base: 'auto', md: 'auto', lg: '0' }}
                    mb={{ base: '0', md: '0', lg: '0' }}
                    className="waves-text-image"
                    maxWidthPx={481}
                  />
                  <Flex
                    w={'100%'}
                    justifyContent={{ base: 'center', sm: 'space-between' }}
                    gap={'20px'}
                    px={{ base: 'auto', md: '20px', xl: '45px' }}
                  >
                    <Box
                      maxWidth={{
                        base: '100%',
                        sm: '100%',
                        md: '189px',
                        lg: '200px',
                      }}
                      w={{
                        base: '100%',
                        sm: '100%',
                        md: '50%',
                        lg: '100%',
                      }}
                    >
                      <SingleImage
                        objectFit="contain"
                        alignSelf={{
                          base: 'flex-start',
                          sm: 'center',
                          md: 'flex-start',
                        }}
                        width={{ base: '100%', sm: '149px', md: 'max-content' }}
                        sectionContent={sectionContent[11]}
                        alt="7 step text"
                        sync="true"
                        maxWidthPx={481}
                        my="0px"
                        className="Step7TextImage"
                      />
                    </Box>

                    <Box
                      display={{ base: 'none', md: 'flex' }}
                      mt={{ base: '0', md: '10px' }}
                    >
                      {getSimpleButton()}
                    </Box>
                  </Flex>
                </Flex>
              </Box>
            </Box>
            <Box
              pos={{ base: 'static', sm: 'absolute' }}
              h={{
                base: '100%',
              }}
              right={'0px'}
              w={{
                base: '100%',
                sm: 'max-content',
              }}
              maxW={{
                base: '100%',
                sm: 'max-content',
              }}
              mx={{ base: '0', sm: '0' }}
              zIndex={2}
              bottom="0"
              mt={'auto'}
            >
              {getSadGuruImage()}
            </Box>
          </Box>
        </ProgressiveBg>
      </Box>
      <Box position={'relative'}>
        <Box
          display={{ base: 'block', md: 'none' }}
          mx="auto"
          pos={{ base: 'absolute', md: 'static' }}
          bottom={{
            base: '-30px',
          }}
          left="50%"
          w="100%"
          transform={{ base: 'translateX(-50%)', md: 'none' }}
          h="auto"
          zIndex={150}
        >
          {getSimpleButton()}
        </Box>
      </Box>
      {isWavesOfBlissWAPage ? (
        <WPChatButton
          region={region}
          lang={lang}
          isPopup={isPopup}
          setIsPopup={setIsPopup}
          pageData={pageData}
        />
      ) : (
        isWavesOfBlissILPage && (
          <InlineEnquireForm
            region={region}
            lang={lang}
            isPopup={isPopup}
            setIsPopup={setIsPopup}
            pageData={pageData}
          />
        )
      )}
      <style jsx global>
        {`
          .Step7TextImage {
            max-width: 100% !important;
            @media (width >= 480px) {
              max-width: 100% !important;
            }
            @media (width >= 768px) {
              max-width: 150px !important;
            }
            @media (width >= 1068px) {
              max-width: 100% !important;
            }
          }
          .wavesOfBlissBanner {
            height: auto;
            @media (width >= 480px) {
              height: 340px;
            }
            @media (width >= 768px) {
              height: 450px;
            }
            @media (width >= 930px) {
              height: 580px;
            }
            @media (width >= 1068px) {
              height: 650px;
            }
            @media (width >= 1536px) {
              height: 733px;
            }
          }
          .waves-text-image {
            max-width: 100% !important;
            @media (width >= 480px) {
              max-width: 500px !important;
            }
            @media (width >= 768px) {
              max-width: 360px !important;
            }
            @media (width >= 868px) {
              max-width: 460px !important;
            }
            @media (width >= 1068px) {
              max-width: 580px !important;
            }
            @media (width >= 1536px) {
              max-width: 633px !important;
            }
          }
          .sadhguruImage {
            max-width: 100%;
            img {
              width: 100%;
            }
            @media (width >= 480px) {
              max-width: 300px;
            }
            @media (width >= 560px) {
              max-width: 350px;
              margin-top: 25px !important;
            }
            @media (width >= 640px) {
              max-width: 380px;
            }
            @media (width >= 768px) {
              max-width: 430px;
              margin-top: 0px !important;
            }
            @media (width >= 800px) {
              max-width: 400px;
            }
            @media (width >= 868px) {
              max-width: 400px;
            }
            @media (width >= 930px) {
              max-width: 540px;
            }
            @media (width >= 940px) {
              max-width: 550px;
            }
            @media (width >= 980px) {
              max-width: 580px;
            }
            @media (width >= 1068px) {
              max-width: 615px;
            }
            @media (width >= 1090px) {
              max-width: 635px;
            }
            @media (width >= 1140px) {
              max-width: 680px;
            }
            @media (width >= 1200px) {
              max-width: 760px;
            }
            @media (width >= 1230px) {
              max-width: 800px;
            }
            @media (width >= 1300px) {
              max-width: 840px;
            }
            @media (width >= 1536px) {
              max-width: 880px;
            }
            @media (width >= 1620px) {
              max-width: 880px;
            }
            @media (width >= 1736px) {
              max-width: 1000px;
            }
            @media (width >= 1899px) {
              max-width: 1050px;
            }
          }
        `}
      </style>
    </>
  );
};

export default TopBannerEvent;
